import { motion } from "framer-motion";
import { Hammer, PenTool, PhoneCall, Rocket } from "lucide-react";
import { EASE } from "@/lib/lenis";
import { Reveal } from "@/components/motion/Reveal";
import { SectionIntro } from "@/components/site/Bits";

const STEPS = [
  {
    icon: PhoneCall,
    chip: "15 min",
    title: "15-minute call",
    copy: "Tell us about your business, your customers, and what you need. No prep required.",
  },
  {
    icon: PenTool,
    chip: "Free",
    title: "Free mockup",
    copy: "We design a mockup of your new homepage, so you can see it before you commit.",
  },
  {
    icon: Hammer,
    chip: "7–10 days",
    title: "7–10 day build",
    copy: "Once you approve, we build, write, and test the full site at a fixed price.",
  },
  {
    icon: Rocket,
    chip: "Ongoing",
    title: "Launch & support",
    copy: "We launch, connect your domain, and stay on hand for updates and questions.",
  },
];

export const HowItWorks = () => (
  <section className="section border-t border-white/[0.08]" data-testid="how-it-works-section">
    <div className="container-x">
      <SectionIntro eyebrow="How it works" title={["From first call to launch,", "in four steps."]} testId="how-it-works-heading" />
      <Reveal>
        <ol className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-white/[0.08] bg-white/[0.08] sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map(({ icon: Icon, chip, title, copy }, i) => (
            <li key={title} className="relative flex min-h-[260px] flex-col bg-[#0A0B0D] p-6 sm:p-8" data-testid={`how-step-${i + 1}`}>
              <motion.span
                aria-hidden="true"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1, ease: EASE, delay: 0.3 + i * 0.25 }}
                className="absolute inset-x-0 top-0 h-px origin-left bg-gradient-to-r from-[#2563EB] to-[#2DD4D4]"
              />
              <div className="flex items-center justify-between">
                <span className="font-mono text-sm text-[#A1A1AA]">0{i + 1}</span>
                <span className="rounded-full border border-white/10 bg-white/[0.03] px-2.5 py-1 font-mono text-xs text-white/85">{chip}</span>
              </div>
              <Icon className="mt-12 h-6 w-6 text-[#2F6BFF]" aria-hidden="true" />
              <h3 className="mt-5 text-xl font-medium tracking-tight">{title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[#A1A1AA]">{copy}</p>
            </li>
          ))}
        </ol>
      </Reveal>
    </div>
  </section>
);
